/** @format */

export default function() {
  return [
    // {
    //   title: '序号',
    //   width: 70,
    //   customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`,
    // },
    {
      title: '车场名称',
      dataIndex: 'parkName',
      width: 180,
      scopedSlots: { customRender: 'text-ellipse' }
    },
    {
      title: '参考车牌号',
      dataIndex: 'plate',
      width: 120
    },
    {
      title: '进出场类型',
      dataIndex: 'direction',
      width: 120
    },
    {
      title: '通道名称',
      dataIndex: 'channelName',
      width: 180,
      scopedSlots: { customRender: 'text-ellipse' }
    },
    {
      title: '抬杆时间',
      dataIndex: 'liftTime',
      width: 200,
      sortable: true
    },
    {
      title: '抬杆原因',
      dataIndex: 'liftCauseName',
      width: 120
    },
    {
      title: '备注',
      dataIndex: 'descrpition',
      width: 200
    },
    {
      title: '操作来源',
      dataIndex: 'liftTypeName',
      width: 160
    },
    // {
    //   title: '抬杆方式',
    //   dataIndex: 'liftTypeName',
    //   width: 120,
    // },
    {
      title: '操作人',
      dataIndex: 'operater',
      width: 140,
      scopedSlots: { customRender: 'text-ellipse' }
    },
    {
      title: '停车订单号',
      dataIndex: 'orderId',
      width: 340,
      scopedSlots: { customRender: 'pkOrderId' }
    },

    {
      title: '图片详情',
      dataIndex: 'img',
      width: 100,
      scopedSlots: { customRender: 'viewImg' }
    },
    {
      title: '审核状态',
      dataIndex: 'reviewStatusName',
      width: 100,
      scopedSlots: { customRender: 'status' }
    },
    {
      title: '审核时间',
      dataIndex: 'reviewTime',
      width: 200
    },
    {
      title: '审核意见',
      dataIndex: 'reviewDescription',
      width: 180,
      scopedSlots: { customRender: 'text-ellipse' }
    },
    {
      title: '审核人',
      dataIndex: 'reviewer',
      width: 140,
      scopedSlots: { customRender: 'text-ellipse' }
    }

    // {
    //   title: '操作',
    //   dataIndex: 'operation',
    //   fixed: 'right',
    //   width: 154,
    //   scopedSlots: { customRender: 'operation' },
    // },
    // {
    //   title: '操作',
    //   dataIndex: 'operation',
    //   fixed: 'right',
    //   width: 154,
    //   scopedSlots: { customRender: 'operation' },
    // },
  ];
}
